import React, { FC } from 'react';
import { Drawer } from '@mui/material';

interface CustomDrawerProps {
  isOpen: boolean;
  size?: string;
  handleClose: () => void;
}

const defaultProps = {
  size: undefined,
};

export const CustomDrawer: FC<CustomDrawerProps> = ({ isOpen, handleClose, size, children }) => {
  return (
    <Drawer
      anchor="right"
      className={`custom-drawer ${isOpen ? 'custom-drawer_visible' : 'custom-drawer_hidden'} ${size && size}`}
      open={isOpen}
      onClose={handleClose}
    >
      {children}
    </Drawer>
  );
};

CustomDrawer.defaultProps = defaultProps;
